import { CSS_VARIABLES } from "enums/cssVariables";

export const styles = `
    ${CSS_VARIABLES.PRIMARY_BUTTON_BACKGROUND_COLOR}: #F17E22;
    ${CSS_VARIABLES.PRIMARY_TEXT_COLOR}: #F17E22;
`;
